import {
  BarChart3,
  Bell,
  BookOpen,
  BotMessageSquare,
  FlaskConical,
  House,
  Lock,
  SlidersHorizontal,
  Target,
  UserCog,
  UsersRound
} from "lucide-react";
import { buildRouteConfig } from "@vojomo-core/shared";

const config = [
  {
    path: "/",
    component: "Home",
    title: "Vojomo Admin",
    icon: House
  },
  {
    path: "vojomo_internal",
    component: "VojomoInternal",
    title: "Vojomo Internal",
    icon: Lock
  },
  {
    path: "members",
    component: "Members",
    title: "Members",
    icon: UsersRound,
    children: [
      {
        path: ":id",
        component: "Member",
        title: "Member",
        notSidebar: true
      }
    ]
  },
  {
    path: "modus",
    component: "Modus",
    title: "Modus",
    icon: BotMessageSquare
  },
  {
    path: "agent_creator",
    component: "AgentCreator",
    title: "Agent Creator",
    icon: FlaskConical
  },
  {
    path: "modus_config",
    component: "ModusConfig",
    title: "Modus Config",
    icon: SlidersHorizontal,
    children: [
      {
        path: ":id",
        component: "AgentDtls",
        title: "Agent Details",
        notSidebar: true
      }
    ]
  },
  {
    path: "qbr_dashboard",
    component: "QBRDashboard",
    title: "CSG QBR Dashboard",
    icon: Target
  },
  {
    path: "advisors",
    component: "Advisors",
    title: "Advisors",
    icon: UserCog
  },
  {
    path: "analytics",
    component: "Analytics",
    title: "Analytics",
    icon: BarChart3
  },
  {
    path: "notifications",
    component: "Notifications",
    title: "Notifications",
    icon: Bell
  },
  {
    path: "glossary",
    component: "Glossary",
    title: "UX Glossary",
    icon: BookOpen
  },
  {
    path: "unauthorized",
    component: "Unauthorized",
    title: "Unauthorized",
    notSidebar: true
  }
];

export const routeConfig = buildRouteConfig(config);
